module.exports = __webpack_public_path__ + "img/6e4657fff41d49ff8bfe3999efed2729.png";